import { escapeHtml } from "@components/JobFamilyConfirmDialog/jobFamilyConfirmDialog.js";

export function deleteInfoHtml(name) {
  const safeName = escapeHtml(String(name || "").trim() || "this job family");
  return `<div style="max-width: 414px; margin: 0 auto; margin-top: 26px;">You are about to permanently delete Job Family ${safeName}.</div>`;
}
